export default __webpack_public_path__ + "static/media/logo_white.2086ef05.png";